// extracted by mini-css-extract-plugin
module.exports = {"root":"filter-pagination-container_root__tNDlu","filters":"filter-pagination-container_filters__OkehH","pagination":"filter-pagination-container_pagination__h_C4o"};